import React, { useEffect, useState } from "react";

import supabase from "../config/supabaseClient";
import estilo from "../styles/Inicio.module.css";
import Tarjetas from "../components/Tarjetas";
import TarjetaUltimos from "../components/TarjetaUltimos";
import Separador from "../components/Separador";
import Terminados from "../components/Terminados";
import blanco from "../img/blanco.png";
import MetaDecorator from "../utils/MetaDecorator";
import Emision from "../components/Emision";

function Inicio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [emision, setEmision] = useState([]);
  const [lista, setLista] = useState([]);
  const [ultimos, setUltimos] = useState([]);
  const [terminados, setTerminados] = useState([]);
  const [carga, setCarga] = useState(true);

  useEffect(() => {
    const fetchAnime = async () => {
      //en emision
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .eq("estado", true);

        if (error) {
          console.log(error);
          setEmision(null);
        }
        if (data) {
          // console.log("terminados", data);
          setEmision(data);
        }
      } catch (error) {
        console.log("Error Lista de Animes");
      }
      //ultimos capitulos
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .order("ultima_modificacion", { ascending: false })
          .range(0, 11);

        if (error) {
          console.log(error);
          setUltimos(null);
        }
        if (data) {
          setUltimos(data);
        }
      } catch (error) {
        console.log("Error Ultimos Animes");
      }
      //animes terminados
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .eq("completado", true)
          .order("ultima_modificacion", { ascending: false })
          .range(0, 5);

        if (error) {
          console.log(error);
          setTerminados(null);
        }
        if (data) {
          // console.log("terminados", data);
          setTerminados(data);
        }
      } catch (error) {
        console.log("Error Lista de Animes");
      }
      //ultimos animes
      try {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .order("id", { ascending: false })
          .range(0, 11);

        if (error) {
          console.log(error);
          setLista(null);
        }
        if (data) {
          setLista(data);
          // console.log(data);
        }
        setCarga(false);
      } catch (error) {
        console.log("Error Lista de Animes");
      }
    };
    fetchAnime();
  }, []);

  // function bucleComa(e) {
  //   var salida = "";
  //   for (let i = 0; i < e.length; i++) {
  //     if (1 == e.length) {
  //       salida += e[i] + ".";
  //     } else {
  //       if (i === e.length - 1) {
  //         salida += "y " + e[i] + ".";
  //       } else if (i === e.length - 2) {
  //         salida += e[i] + " ";
  //       } else {
  //         salida += e[i] + ", ";
  //       }
  //     }
  //   }
  //   return salida;
  // }

  // const arr = ["1", "2", "3"];

  // function bucleComa(e) {
  //   let result = "";
  //   for (let i = 0; i < e.length; i++) {
  //     if (i === e.length - 2) {
  //       result += e[i] + " y ";
  //     } else if (i === e.length - 1) {
  //       result += e[i] + ".";
  //     } else {
  //       result += e[i] + ", ";
  //     }
  //   }
  //   return result;
  // }

  // console.log(bucleComa(arr));

  return (
    <div className={estilo.contenedor_inicio}>
      <MetaDecorator
        titulo={"yTAnimeTV - Animes Sub Español Online"}
        subtitulo={"ytanimetv.com"}
        descripcion={
          "La mejor pagina para Ver Anime Online en subtitulados al Español, mira los ultimos capitulos de los animes actuales totalmente gratis."
        }
        keywords={
          "anime online español, anime online gratis, anime online naruto, anime online naruto shippuden, anime online sub español, anime online free, anime online latino, anime online bleach, animes, anime, ecchi, anime online, Naruto Shippuden, Anime online, Anime en Descarga Directa, Ver Anime Online."
        }
        url={"https://ytanimetv.com/"}
        canonical={"https://ytanimetv.com/"}
      />

      <Separador titulo="Animes en Emisión"></Separador>

      {carga ? (
        <div className={estilo.carga_emision}>
          <div className={estilo.carga1}>
            <img src={blanco} alt="cargando" />
          </div>
          <div className={estilo.carga2}>
            <img src={blanco} alt="cargando" />
          </div>
          <div className={estilo.carga3}>
            <img src={blanco} alt="cargando" />
          </div>
          <div className={estilo.carga4}>
            <img src={blanco} alt="cargando" />
          </div>
          <div className={estilo.carga5}>
            <img src={blanco} alt="cargando" />
          </div>
        </div>
      ) : (
        <div className={estilo.emision}>
          <Emision emision={emision}></Emision>
        </div>
      )}
      <Separador titulo="Últimos Capítulos Agregados"></Separador>

      {carga ? (
        <div className={estilo.carga}>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
          <div className={estilo.cuadro}>
            <img src={blanco} alt="carga" />
          </div>
        </div>
      ) : (
        <div>
          {ultimos && (
            <div className={estilo.TarjetaUltimos_grid}>
              {ultimos.map((e) => (
                <TarjetaUltimos key={e.id} ultimos={e}></TarjetaUltimos>
              ))}
            </div>
          )}
        </div>
      )}

      <Separador titulo="Animes Terminados"></Separador>

      {terminados && (
        <div className={estilo.terminados_grid}>
          {terminados.map((e) => (
            <Terminados key={e.id} terminados={e}></Terminados>
          ))}
        </div>
      )}

      <Separador titulo="Últimos Animes Agregados"></Separador>

      {carga ? (
        <div className={estilo.carga_2}>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={estilo.cuadro_2}>
            <img src={blanco} alt="carga" />
            <div className={estilo.texto}>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={`${estilo.cuadro_2} ${estilo.boton}`}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <div>
          {lista && (
            <div className={estilo.tarjetas_grid}>
              {lista.map((e) => (
                <Tarjetas key={e.id} lista={e}></Tarjetas>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Inicio;
